import React, { useCallback, memo } from 'react';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import {
  ReportCurrency,
  ReportType,
  ClientCustomCalendarModel,
} from '../../../../models';
import * as Styled from '../styled';
import DateRange, {
  DateRangeLabel,
  DateRangeMode,
} from '../date-range/DateRange';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';
import ReportSettingPIT from '../ReportSettingPIT';

interface ReportSettingDisclosureProps {
  onChange: (updatedValue: ReportSettingDisclosureState) => void;
  reportSettingState: ReportSettingDisclosureState;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
  customCalendarSettings?: ClientCustomCalendarModel;
}

export interface ReportSettingDisclosureState {
  selectedCurrency: SelectOption<ReportCurrency>;
  startDate: string;
  endDate: string;
  selectedViewBy: SelectOption<string>;
  isValid: boolean;
}

function ReportDateSettingDisclosure({
  onChange,
  reportSettingState,
  reportTypeSetting,
  isAllowPIT,
  customCalendarSettings,
}: ReportSettingDisclosureProps): JSX.Element {
  const dateRangeLabel: DateRangeLabel = {
    Start: 'Start Date',
    End: 'End Date',
  };

  const mode =
    DateRangeMode[
      customCalendarSettings.isCustomCalendarEnabled
        ? 'CustomCalendar'
        : 'ShortDate'
    ];

  return (
    <>
      <DateRange
        onChange={useCallback(
          (startDate: string, endDate: string, isValid: boolean): void => {
            onChange({
              ...reportSettingState,
              startDate: startDate,
              endDate: endDate,
              isValid: isValid,
            });
          },
          [onChange, reportSettingState],
        )}
        startDate={reportSettingState.startDate}
        endDate={reportSettingState.endDate}
        mode={mode}
        dateRangeLabel={dateRangeLabel}
        customCalendarPeriods={customCalendarSettings.numberOfPeriods}
      />
      <Styled.Line />
      <ReportSettingPIT
        reportType={ReportType.disclosure}
        isAllowPIT={isAllowPIT}
        reportSettingState={reportSettingState}
        reportTypeSetting={reportTypeSetting}
        customCalendarSettings={customCalendarSettings}
        onChange={useCallback(
          (state) => onChange(state as ReportSettingDisclosureState),
          [onChange],
        )}
      />
    </>
  );
}

export default memo(ReportDateSettingDisclosure);
